module.exports = __webpack_public_path__ + "static/media/Inky_BenjaminGoldhagen.e95e33be.png";